const artworkData = [
  {
    "edition": "2021 reissue · vinyl",
    "modified": "2021-02-17T22:18:11Z",
    "preview": "assets/dropbox/a-b-life-sticker.png",
    "release": "a-b-life",
    "role": "sticker",
    "source": "LP1 - [A-->B] Life/Artwork/2021 Reissue/Standard LP/5 - Sticker/AB-Life-Vinyl Sticker.pdf"
  },
  {
    "edition": "Standard vinyl · sticker and placement proof",
    "modified": "2021-10-27T16:36:36Z",
    "preview": "assets/dropbox/catch-for-us-the-foxes-sticker.png",
    "release": "catch-for-us-the-foxes",
    "role": "sticker",
    "source": "LP2 - Catch for us the Foxes/Artwork/Standard Vinyl/4 Cover Sticker/300x90mm Cover Sticker.pdf"
  },
  {
    "edition": "2020 reissue · vinyl sticker and placement proof",
    "modified": "2020-03-31T21:28:14Z",
    "preview": "assets/dropbox/brother-sister-sticker.png",
    "release": "brother-sister",
    "role": "sticker",
    "source": "LP3 - Brother, Sister/Artwork/2020 Re-Issue/Standard Edition/5 - Cover Sticker/3.5x1.5 Cover Sticker.pdf"
  },
  {
    "edition": "Original Tooth & Nail CD artwork",
    "modified": "2006-08-28T18:23:20Z",
    "preview": "assets/dropbox/brother-sister-bandLogo.png",
    "release": "brother-sister",
    "role": "bandLogo",
    "source": "LP3 - Brother, Sister/Artwork/Tooth & Nail CD/Artwork/mwy_hand-drawn_logo.tif"
  },
  {
    "edition": "Standard vinyl",
    "modified": "2020-09-29T19:16:16Z",
    "preview": "assets/dropbox/its-all-crazy-sticker.png",
    "release": "its-all-crazy",
    "role": "sticker",
    "source": "LP4 - It's All Crazy!/Artwork/Standard LP/5 - Sticker/ItsAllCrazy-Vinyl Sticker.pdf"
  },
  {
    "edition": "2022 reissue · standard vinyl",
    "modified": "2022-02-23T23:03:05Z",
    "preview": "assets/dropbox/ten-stories-sticker.png",
    "release": "ten-stories",
    "role": "sticker",
    "source": "LP5 - Ten Stories/Artwork/2022 Re-Issue/Standard LP/5 - Sticker/TenStories-Vinyl Sticker.pdf"
  },
  {
    "edition": "Maxi single · vinyl",
    "modified": "2014-08-06T02:02:24Z",
    "preview": "assets/dropbox/east-enders-wives-sticker.png",
    "release": "east-enders-wives",
    "role": "sticker",
    "source": "LP5 - Ten Stories/Singles/East Enders Wives - Maxi Single/Artwork/Vinyl/5. 2.5\"x 1\" Black Sticker/BlackSticker.pdf"
  },
  {
    "edition": "2023 reissue · vinyl die-cut sticker",
    "modified": "2023-09-01T16:41:08Z",
    "preview": "assets/dropbox/pale-horses-sticker.png",
    "release": "pale-horses",
    "role": "sticker",
    "source": "LP6 - Pale Horses/Artwork/2023 Re-Issue/Vinyl/5 - Cover Sticker/PaleHorses-DieCutSticker.pdf"
  },
  {
    "edition": "Logo & typeface source sheet",
    "modified": "2023-09-06T10:41:02Z",
    "preview": "assets/dropbox/pale-horses-reference.png",
    "release": "pale-horses",
    "role": "reference",
    "source": "LP6 - Pale Horses/Artwork/Assets/Pale Horses Logo & Typeface.ai"
  },
  {
    "edition": "CD cover sticker",
    "modified": "2023-07-18T20:54:35Z",
    "preview": "assets/dropbox/pale-horses-appendix-sticker.png",
    "release": "pale-horses-appendix",
    "role": "sticker",
    "source": "EP2 - Pale Horses Appendix/Artwork/CD/4 - Cover Sticker/PaleHorsesAppendix-CD Sticker.pdf"
  },
  {
    "edition": "Black vinyl version · sticker placement proof",
    "modified": "2018-08-10T20:35:53Z",
    "preview": "assets/dropbox/untitled-sticker.png",
    "release": "untitled",
    "role": "sticker",
    "source": "LP7 - [Untitled]/Artwork/Album Vinyl/Black/Cover Sticker - Black Version.pdf"
  },
  {
    "edition": "Black vinyl version · sticker placement proof",
    "modified": "2018-08-01T18:33:34Z",
    "preview": "assets/dropbox/untitled-ep-sticker.png",
    "release": "untitled-ep",
    "role": "sticker",
    "source": "EP3 - [untitled]/Artwork/EP Vinyl/Black/Cover Sticker - Black Version.pdf"
  },
  {
    "edition": "CD cover sticker",
    "modified": "2023-02-08T00:01:52Z",
    "preview": "assets/dropbox/i-never-said-that-i-was-brave-sticker.png",
    "release": "i-never-said-that-i-was-brave",
    "role": "sticker",
    "source": "EP1 - I Never Said That I Was Brave/Artwork/CD/4 - Cover Sticker/INeverSaidThatIWasBrave-CD Sticker.pdf"
  },
  {
    "edition": "Hand-painted vinyl · handwritten title",
    "modified": "2024-03-14T19:16:07Z",
    "preview": "assets/dropbox/i-never-said-that-i-was-brave-albumLogo.png",
    "release": "i-never-said-that-i-was-brave",
    "role": "albumLogo",
    "source": "EP1 - I Never Said That I Was Brave/Artwork/Hand-Painted Vinyl/Handwritten-Title.png"
  },
  {
    "edition": "Live Volume One logo",
    "modified": "2026-01-31T17:41:31Z",
    "preview": "assets/dropbox/live-vol-one-albumLogo.svg",
    "release": "live-vol-one",
    "role": "albumLogo",
    "source": "LIVE/Artwork/Assets/Logos/Volume1-Logo.svg"
  },
  {
    "edition": "Live Volume Two logo",
    "modified": "2026-01-31T17:41:16Z",
    "preview": "assets/dropbox/live-vol-two-albumLogo.svg",
    "release": "live-vol-two",
    "role": "albumLogo",
    "source": "LIVE/Artwork/Assets/Logos/Volume2-Logo.svg"
  },
  {
    "edition": "Live Volume Three logo",
    "modified": "2026-01-31T17:40:53Z",
    "preview": "assets/dropbox/live-vol-three-albumLogo.svg",
    "release": "live-vol-three",
    "role": "albumLogo",
    "source": "LIVE/Artwork/Assets/Logos/Volume3-Logo.svg"
  },
  {
    "edition": "Vinyl cover sticker",
    "modified": "2025-01-31T15:50:36Z",
    "preview": "assets/dropbox/live-vol-one-sticker.png",
    "release": "live-vol-one",
    "role": "sticker",
    "source": "LIVE/Artwork/Volume 1/Vinyl/6 - Cover Sticker/Vol1-CoverSticker.ai"
  },
  {
    "edition": "Vinyl cover sticker",
    "modified": "2025-07-09T21:32:28Z",
    "preview": "assets/dropbox/live-vol-two-sticker.png",
    "release": "live-vol-two",
    "role": "sticker",
    "source": "LIVE/Artwork/Volume 2/Vinyl/6 - Cover Sticker/Vol2-CoverSticker.ai"
  },
  {
    "edition": "Vinyl cover sticker",
    "modified": "2026-03-07T01:45:50Z",
    "preview": "assets/dropbox/live-vol-three-sticker.png",
    "release": "live-vol-three",
    "role": "sticker",
    "source": "LIVE/Artwork/Volume 3/Vinyl/6 - Cover Sticker/Vol3-CoverSticker.ai"
  }
];
